import { Loading } from 'components/loading/Loading';
import CustomLink from 'components/TableLink';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useState } from 'react';
import DataTable from 'components/DataTable';
import { fetchAllCategoryGroups } from 'services';
import { showError } from 'utils';
import styles from './index.module.scss';

const columns = [
  {
    name: 'Cateory Group ID',
    selector: 'objectId',
    sortable: false,
    width: '180px',
    // eslint-disable-next-line react/display-name
    cell: row => (
      <CustomLink
        text={row.objectId}
        linkTo={`/category-groups/${row.objectId}`}
      />
    ),
  },
  {
    name: 'Name',
    selector: 'name',
    sortable: true,
    // eslint-disable-next-line react/display-name
    cell: row => (
      <div className={styles['category-name']} onClick={() => window.location.assign(`/category-groups/${row.objectId}`)}>
        <img src={row.image._url} alt={row.name} />
        <div>{row.name || '-'}</div>
      </div>
    ),
  },
  {
    name: 'Slug',
    selector: 'slug',
    sortable: true,
  },
];

const CategoryGroups = props => {
  const [groups, setGroups] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchAllGroups = async () => {
    setLoading(true);
    try {
      const response = await fetchAllCategoryGroups();
      setGroups(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllGroups();
  }, []);

  if (loading) return <Loading />;
  
  return (
    <>
      <div className={styles['header']}>
        <div className={styles['heading']}>Category Groups</div>
      </div>
      <DataTable
        keyField="objectid"
        columns={columns}
        noHeader={true}
        data={groups}
        highlightOnHover={true}
        customStyles={tableStyles}
        pagination={false}
      />
    </>
  );
};

export { CategoryGroups };